import { render, staticRenderFns } from "./ModalEliminarPago.vue?vue&type=template&id=4a606ce3&"
import script from "./ModalEliminarPago.vue?vue&type=script&lang=js&"
export * from "./ModalEliminarPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports